import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CheckBilanciEffects } from './+state/check-bilanci.effects';
import { CheckBilanciFacade } from './+state/check-bilanci.facade';
import {
  CHECK_CHIUSURE_FEATURE_KEY,
  reducer,
} from './+state/check-bilanci.reducer';
import { CheckChiusuraEsercizioGuard } from './guards/check-chiusura-esercizio.guard';
import { CheckConsolidatoGuard } from './guards/check-consolidato.guard';
import { CheckDatiRiepilogoModificatiGuard } from './guards/check-dati-riepilogo-modificati.guard';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(CHECK_CHIUSURE_FEATURE_KEY, reducer),
    EffectsModule.forFeature([CheckBilanciEffects]),
  ],
})
export class AppCheckBilanciModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppCheckBilanciModule
  ) {
    if (parentModule) {
      throw new Error(
        'AppCheckBilanciModule is already loaded. Import only in AppModule'
      );
    }
  }

  static forRoot(): ModuleWithProviders<AppCheckBilanciModule> {
    return {
      ngModule: AppCheckBilanciModule,
      providers: [
        CheckBilanciFacade,
        CheckChiusuraEsercizioGuard,
        CheckConsolidatoGuard,
        CheckDatiRiepilogoModificatiGuard,
      ],
    };
  }
}
